import MagicBento from '../components/MagicBento'
// Multi-Model Platform carousel kept for future use.
// import LogoLoop from '../components/LogoLoop';
// import { ClaudeLogo} from '../icons/Logos';
// import { OpenAILogo} from '../icons/Logos';
// import { GeminiLogo} from '../icons/Logos';
// import { HuggingFaceLogo} from '../icons/Logos';
// import { MetaLogo} from '../icons/Logos';

const cardData =   [
    {  color: '#060010',
      title: 'Workspace Organization',
      description: 'Keep prompts & agents tidy.',
      label: 'Organize'
    },
    {
      color: '#060010',
      title: 'Prompt Editor',
      description: 'Edit prompts with ease.',
      label: 'Editor'
    },
    {
      color: '#060010',
      title: 'Prompt Enhancement',
      description: 'Boost Clarity and precision with AI-powered suggestions.',
      label: 'Enhance'
    },
    {
      color: '#060010',
      title: 'Prompt Testing',
      description: 'Test your and compare your prompt with more than one agent or model',
      label: 'Test'
    },
    {
      color: '#060010',
      title: 'Version Control',
      description: 'Track changes, compare edits, and roll back anytime.',
      label: 'Track'
    },
    {
      color: '#060010',
      title: 'Team Collaboration',
      description: 'Collaborate with your team in real-time, share prompts and agents.',
      label: 'Collaborate'
    },
    {
      color: '#060010',
      title: 'Agentic AI Workflows',
      description: 'Design and orchestrate agentic AI workflows visually, compose nodes, routes and integrations with ease.',
      label: 'Coming Soon...',
      upcoming: true
    },{
      color: '#060010',
      title: 'Integrations',
      description: 'Connect Promptera with your external applications for seamless automation.',
      label: 'Coming Soon...',
      upcoming: true
    },{
      color: '#060010',
      title: 'Templates',
      description: 'Use ready to use prompt templates for common use cases.',
      label: 'Coming Soon...',
      upcoming: true
    }
  ]

// const techLogos = [
//   { node: <ClaudeLogo />, title: "Claude", href: "https://claude.ai/" },
//   { node: <OpenAILogo />, title: "OpenAI", href: "https://openai.com/" },
//   { node: <GeminiLogo />, title: "Gemini", href: "https://gemini.google/" },
//   { node: <HuggingFaceLogo />, title: "Hugging Face", href: "https://huggingface.co/" },
//   { node: <MetaLogo />, title: "Meta", href: "https://ai.meta.com/" },
// ];


export default function FeaturesStack(){
  return (
    <section id="features" className="section" data-bg="indigo">

      <div className="container" style={{display:'flex',justifyContent:'center',alignItems:'center',paddingTop:24,paddingBottom:24}}>
        <div style={{width:'100%',maxWidth:1224}}>
              <div style={{textAlign:'center',marginBottom:26}}>
                <span className="badge"><i className="fi fi-rr-briefcase" style={{fontSize:14,opacity:.9}}></i> Features</span>
                <h2 style={{fontSize:'clamp(28px,4vw,46px)',margin:'10px 0'}}>Our Features</h2>
                <p className="subtitle" style={{marginTop:0}}>Everything you need to turn prompt chaos into AI clarity.</p>
              </div>
              {/* Top row: services grid with min 260px cards */}
              <MagicBento 
                cards={cardData}
                textAutoHide={true}
                enableStars={false}
                enableSpotlight={true}
                enableBorderGlow={true}
                enableTilt={true}
                enableMagnetism={true}
                clickEffect={true}
                spotlightRadius={200}
                particleCount={12}
                glowColor="75, 20, 181"
              />
        </div>
      </div>

      {/* Multi-Model Platform carousel kept for future use.
      <div className="container" style={{display:'flex',justifyContent:'center',alignItems:'center',paddingTop:24,paddingBottom:24}}>
          <div style={{width:'100%',maxWidth:1224}}>
              <div style={{textAlign:'center',marginBottom:26}}>
                  <h2 style={{fontSize:'clamp(28px,4vw,46px)',margin:'10px 0'}}>Multi-Model Platform</h2>
                  <p className="subtitle" style={{marginTop:0}}>Use multiple AI models in one workspace.</p>
              </div>

              <LogoLoop
              logos={techLogos}
              width={1200}
              speed={80}
              direction="right"
              logoHeight={30}
              gap={40}
              hoverSpeed={40}  
              ariaLabel="Model proiders logos"
              className="glass"
              />
              
          </div>
      </div>
      */}
        
        
    </section>

  )
}
